import * as angular from 'angular';
import * as _ from "lodash";
import {IQService} from "angular";
import {BringozLoaderService} from "../../commons/services/bringoz-loader.service";
import {AttachmentsRequests} from "./attachments-requests.service";

export class AttachmentsService {

  constructor(private attachmentsRequests: AttachmentsRequests, private bringozLoaderService: BringozLoaderService, private $q: IQService) {
  }

  getAttachmentsUrls(names: string[]) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.attachmentsRequests.getAttachmentsUrls(names)
      .then((attachmentsUrls) => {
        deferred.resolve(attachmentsUrls)
      })
      .catch((error) => {
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  getAttachmentsMimeType(name) {
    var mimeType;
    var docType = name.slice(-3);

    if (docType === 'pdf') {
      mimeType = 'application/pdf';
    } else if (docType === 'jpg' || 'peg') {
      mimeType = 'image/jpeg';
    } else if (docType === 'png') {
      mimeType = 'image/png';
    } else {
      mimeType = 'image/jpeg';
    }
    return mimeType;
  }

  addAttachment(attachment) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.attachmentsRequests.addAttachment(attachment)
      .then((res) => {
        deferred.resolve(res)
      })
      .catch((error) => {
        // this.fulfillmentAlertsService.dispatchStepError(error);
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

}

angular
  .module('bringoz.admin.attachments')
  .service('attachmentsService', AttachmentsService);
